export default __webpack_public_path__ + "static/media/logo.c677f136.png";